module.exports = __webpack_public_path__ + "img/thumbnail-header-10.2d6b71a.png";